import { useContext } from "react";
import { ThemeContext } from "../lib/theme-context";
/** The current appearance and its control. Throws outside `ThemeProvider`. */
export function useTheme() {
    const value = useContext(ThemeContext);
    if (value === null) {
        throw new Error("useTheme must be used inside a ThemeProvider.");
    }
    return value;
}
//# sourceMappingURL=use-theme.js.map